import React from "react";

const EmailChangeSuccess = () => {
  return (
    <div className="template-wrapper">
      <h2 className="template-heading">Email Change Success</h2>
      <p className="template-description">
        Your email address has been successfully changed. You can now log in
        with your new email address.
      </p>
      <p
        className="login-btn"
        onClick={() => {
          window.location.href = "/login";
        }}
      >
        Login Now
      </p>
    </div>
  );
};

export default EmailChangeSuccess;
